import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { injectIntl, defineMessages } from 'react-intl';
import SV from 'server-vars';
import classnames from 'classnames';

import PinterestIcon from 'dibs-icons/exports/Pinterest';
import { Link } from 'dibs-elements/exports/Link';

// styles
import styles from './PdpSharedIconBubbles.scss';

// helpers
import { trackPinterestClick } from '../tracking/iconBubblesTracking';
import { pin } from './pdpSharedSocialActions';

// messages
const messages = defineMessages({
    label: {
        id: 'PdpSharedIconBubblePinterest.label',
        defaultMessage: 'Share {title} on pinterest',
    },
    description: {
        id: 'PdpSharedIconBubblePinterest.description',
        defaultMessage:
            '{title} | From a unique collection of {vertical, select, furniture {antique and modern} jewelry {vintage} fashion {rare vintage} other {} } {categoryName} at {dotComHost}{categoryUrl}.',
    },
});

function getValues(item) {
    const categories = item?.classification?.categories;
    const { category } = categories.find(({ precedence }) => precedence === 1);
    return {
        title: item.title,
        vertical: item.vertical,
        categoryName: category.name,
        categoryUrl: category.browseUrl,
        dotComHost: SV.get('localeOrigin'),
    };
}

function onClick({ item, intl }) {
    const { formatMessage } = intl;
    // fire tracking
    trackPinterestClick(item.title);
    // launch pinterest window
    pin({
        newBrowserWindow: true,
        media: item?.photos?.[0]?.largePath,
        url: `${SV.get('localeOrigin')}${item.pdpURL}`,
        description: formatMessage(messages.description, getValues(item)),
    });
}

const className = classnames(styles.bubble, styles.pinterest);
function PdpSharedIconBubblePinterestComponent(props) {
    return (
        <Link
            ariaLabel={props.intl.formatMessage(messages.label, { title: props.item?.title })}
            className={className}
            onClick={() => onClick(props)}
            dataTn="pdp-shared-icon-pinterest"
        >
            <PinterestIcon className={styles.icon} />
        </Link>
    );
}

PdpSharedIconBubblePinterestComponent.propTypes = {
    item: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
};

export const PdpSharedIconBubblePinterest = createFragmentContainer(
    injectIntl(PdpSharedIconBubblePinterestComponent),
    {
        item: graphql`
            fragment PdpSharedIconBubblePinterest_item on Item {
                title
                pdpURL
                vertical
                classification {
                    categories {
                        precedence
                        category {
                            name
                            browseUrl
                        }
                    }
                }
                photos {
                    largePath
                }
            }
        `,
    }
);
